// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Standard Theme CSS */

.standard-theme {
  --primary-color: #1976d2;
  --secondary-color: #f50057;
  --background-color: #f5f5f5;
  --card-bg: #ffffff;
  --text-color: rgba(0, 0, 0, 0.87);
  
  background-color: var(--background-color);
  color: var(--text-color);
  transition: all 0.5s ease;
  font-family: 'Montserrat', sans-serif;
}

/* Add Montserrat font for both themes */

/* Reset any animations or effects from futuristic theme */
.standard-theme .MuiPaper-root {
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important;
  transform: none !important;
}

.standard-theme .MuiPaper-root:hover {
  transform: none !important;
}

/* Hide futuristic elements */
.standard-theme .particles-container,
.standard-theme .cyber-grid {
  display: none;
}

/* Reset button effects */
.standard-theme .MuiButton-contained::before {
  display: none;
}

/* Reset text effects */
.standard-theme .MuiTypography-h4,
.standard-theme .MuiTypography-h5 {
  text-shadow: none;
}

/* Reset icon effects */
.standard-theme .MuiSvgIcon-root {
  filter: none;
}

.standard-theme .MuiSvgIcon-root:hover {
  transform: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/standard-theme.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;;EAEjC,yCAAyC;EACzC,wBAAwB;EACxB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA,wCAAwC;;AAGxC,0DAA0D;AAC1D;EACE,wEAAwE;EACxE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,aAAa;AACf;;AAEA,uBAAuB;AACvB;;EAEE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* Standard Theme CSS */\n\n.standard-theme {\n  --primary-color: #1976d2;\n  --secondary-color: #f50057;\n  --background-color: #f5f5f5;\n  --card-bg: #ffffff;\n  --text-color: rgba(0, 0, 0, 0.87);\n  \n  background-color: var(--background-color);\n  color: var(--text-color);\n  transition: all 0.5s ease;\n  font-family: 'Montserrat', sans-serif;\n}\n\n/* Add Montserrat font for both themes */\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;700&display=swap');\n\n/* Reset any animations or effects from futuristic theme */\n.standard-theme .MuiPaper-root {\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important;\n  transform: none !important;\n}\n\n.standard-theme .MuiPaper-root:hover {\n  transform: none !important;\n}\n\n/* Hide futuristic elements */\n.standard-theme .particles-container,\n.standard-theme .cyber-grid {\n  display: none;\n}\n\n/* Reset button effects */\n.standard-theme .MuiButton-contained::before {\n  display: none;\n}\n\n/* Reset text effects */\n.standard-theme .MuiTypography-h4,\n.standard-theme .MuiTypography-h5 {\n  text-shadow: none;\n}\n\n/* Reset icon effects */\n.standard-theme .MuiSvgIcon-root {\n  filter: none;\n}\n\n.standard-theme .MuiSvgIcon-root:hover {\n  transform: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
